import React from 'react';
import ImageCounterPanelProps from "./props";

function ImageCounterPanel(props: ImageCounterPanelProps) {
  const { show, count, total } = props;
  if (!show) {
    return null;
  }

  return (
    <div data-role="carousel-counter" className="imageCounterPanel">
      <span>{`${count} / ${total}`}</span>
    </div>
  );
}

export default React.memo(ImageCounterPanel);